import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { apiCreateRole, apiUpdateRole } from '@services/ManageRoles/RoleServices';
import { showSuccess, showError } from '@components/notification';

const RoleFormModal = ({ open, onClose, editingRole, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      if (editingRole) {
        form.setFieldsValue({
          name: editingRole.name,
          descriptions: editingRole.descriptions
        });
      } else {
        form.resetFields();
      }
    }
  }, [open, editingRole, form]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      if (editingRole) {
        await apiUpdateRole(values, editingRole.id);
        showSuccess({ message: 'Cập nhật vai trò thành công!' });
      } else {
        await apiCreateRole(values);
        showSuccess({ message: 'Tạo vai trò thành công!' });
      }

      form.resetFields();
      onClose();
      onSuccess();
    } catch (error) {
      showError(error?.message || 'Không thể lưu vai trò');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={editingRole ? 'Chỉnh sửa vai trò' : 'Thêm vai trò mới'}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnClose>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          label={
            <span>
              Tên vai trò <span style={{ color: 'red' }}>*</span>
            </span>
          }
          name="name"
          rules={[
            { required: true, message: 'Vui lòng nhập tên vai trò!' },
            { min: 2, message: 'Tên vai trò phải có ít nhất 2 ký tự!' }
          ]}>
          <Input placeholder="Nhập tên vai trò (ví dụ: admin, manager...)" />
        </Form.Item>

        <Form.Item
          label="Mô tả"
          name="descriptions"
          rules={[{ max: 500, message: 'Mô tả không được vượt quá 500 ký tự!' }]}>
          <Input.TextArea rows={4} placeholder="Nhập mô tả về vai trò này..." />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            Hủy
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            style={{ backgroundColor: '#0051A9', borderColor: '#0051A9' }}>
            {editingRole ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RoleFormModal;
